import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import api from '@/utils/apiClient';
import ModuleViewTabs from './ModuleViewBasicDetails';
import LoadingIcon from 'mdi-react/LoadingIcon';

const ModuleViewDialog = ({ show, onHide, id, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: 'View Module',
    hide: onHide,
  });

  const [state, setState] = React.useState({
    loading: false,
    module: {},
    error: '',
  });

  React.useEffect(() => {
    if (id) getModuleById(+id);
  }, [id]);

  const getModuleById = async (moduleId) => {
    try {
      setState({ ...state, loading: true });
      const { data: res, isSuccess } = await api.cadsAIModule.getModuleById(moduleId);
      if (isSuccess) {
        setState({ ...state, loading: false, module: res.data, error: '' });
      } else {
        throw new Error(res?.messages?.[0] ?? 'Error while getting module details');
      }
    } catch ({ message }) {
      setState({ ...state, loading: false, module: {}, error: message });
      console.error(message);
    }
  };

  const { error, loading, module } = state;

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-view-dialog"
    >
      <div className="modal__header">
        <button
          className="lnr lnr-cross modal__close-btn"
          aria-label="modal__close-btn"
          type="button"
          onClick={modal.hide}
        />
        <h4 className="text-modal  modal__title">{module?.title ?? modal.title}</h4>
      </div>
      {/*Module Modal Body*/}
      <div style={{ padding: 15 }}>
        {loading || !!error ? (
          <>
            {loading && (
              <div className="panel__refresh position-relative" style={{ height: 75 }}>
                <LoadingIcon />
              </div>
            )}
            <div className="text-center">
              {error && (
                <div>
                  <span className="lnr lnr-cross-circle modal__title-icon error" />
                </div>
              )}
              {loading ? 'Getting module details...' : error}
            </div>
          </>
        ) : (
          <>
            <ModuleViewTabs module={module} />
          </>
        )}
      </div>
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(ModuleViewDialog);
